import { useEffect, useMemo, useState } from 'react';
import { printerService } from '../services/printer';

export const usePrinterService = () => {
  const [state, setState] = useState(() => printerService.getState());

  useEffect(() => {
    const unsubscribe = printerService.subscribe(setState);
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  return useMemo(
    () => ({
      state,
      discoverDevices: (options) => printerService.discoverDevices(options),
      connect: (device, options) => printerService.connect(device, options),
      disconnect: () => printerService.disconnect(),
      printInvoice: (invoice, options) => printerService.printInvoice(invoice, options),
      printRaw: (payload, options) => printerService.printRaw(payload, options),
      testPrint: (options) => printerService.testPrint(options),
      restorePersistedConnection: (options) =>
        printerService.restorePersistedConnection(options),
      enqueueJob: (invoice, options) => printerService.enqueueJob(invoice, options),
      markJobComplete: (jobId, status) => printerService.markJobComplete(jobId, status),
      clearQueue: () => printerService.clearQueue(),
      flushQueue: (options) => printerService.flushQueue(options),
      getStatus: () => printerService.getStatus(),
    }),
    [state],
  );
};

